import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { BrowserRouter } from 'react-router-dom'

// CRA sets PUBLIC_URL to "" at root, or "/tsr" for production deploy (.env.production)
const publicUrl = (process.env.PUBLIC_URL || '').replace(/\/$/, '');
const routerBasename = publicUrl || undefined;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter basename={routerBasename}>
    <App />
  </BrowserRouter>
);
